import { RefObject } from 'react';
import { captureException } from '../tracking/sentry/sentry';
import { sendEventTYPED } from './analytics';
import { EVENT_NAME } from './events';

export const sendViewVideoEvent = ({ videoId }: { videoId: number | undefined }) => {
  if (!videoId) {
    captureException(new Error('Video showed but is not defined, cannot send view analytics'));
    return;
  }
  sendEventTYPED({
    name: EVENT_NAME.VIEW_VIDEO,
    properties: {
      'video id': videoId,
      location: window.location.pathname,
    },
  });
};

export const sendViewVideoCompletedEvent = ({
  videoId,
  videoRef,
}: {
  videoId: number;
  videoRef: RefObject<HTMLVideoElement>;
}) => {
  if (!videoRef.current) {
    captureException(
      new Error('Video closed but ref is not defined, cannot send completion analytics'),
      {
        extra: {
          id: videoId,
        },
      },
    );
    return;
  }
  const { currentTime, duration } = videoRef.current;
  sendEventTYPED({
    name: EVENT_NAME.VIEW_VIDEO_COMPLETED,
    properties: {
      'video id': videoId,
      location: window.location.pathname,
      'total video duration in seconds': Math.round(duration),
      'watched video duration in seconds': Math.round(currentTime),
      'watched video percentage': Math.round((10 * currentTime) / duration) / 10,
    },
  });
};
